<template>
  <div class="wrapper">
    <div class="tab white_box">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="人员数量" name="first">
          <div class="filter">
            <!-- <el-select
              class="custom-os"
              v-model="selectedValue"
              @change="changeHandle1_1"
              clearable
              filterable
              default-first-option
              size="medium"
              placeholder="请选择组织或输入关键字搜索"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
            <el-select
              class="custom-os"
              v-model="cycle"
              @change="changeHandle1_2"
              filterable
              default-first-option
              size="medium"
              placeholder="请选择统计周期"
            >
              <el-option
                v-for="item in cycleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-date-picker
              class="custom-zone"
              v-model="during"
              :picker-options="pickerOptions"
              type="monthrange"
              align="center"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="zoneChange"
            ></el-date-picker>
          </div>
          <div class="h_padding48 content">
            <div class="line_box box">
              <!-- 折线图容器 -->
              <div id="line"></div>

              <div class="download">
                <a class="download_pic" @click="downloadPicture('line', '人员数量统计图')">保存图片</a>
                
              </div>
            </div>
            <!-- 折线图右侧的图例 -->
            <div class="legends">
              <div class="legend-item row">
                <span class="point" style="background: #f26828;"></span>
                <p class="font_14_gray legend-name">{{cycleName}}末在职人数</p>
                <div class="row">
                  <p class="font_24_black">{{lineShowDetail.periodEndOnJobCount}}</p>
                  <!-- <img src="@/assets/icons/up@2x.png" alt />
                  <img src="@/assets/icons/down@2x.png" alt />
                  <span class="font_12_green">0.66%</span>
                  <span class="font_12_red">0.66%</span>-->
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #5c74f5;"></span>
                <p class="font_14_gray legend-name">新进人数</p>
                <div class="row">
                  <p class="font_24_black">{{lineShowDetail.periodNewHireCount}}</p>
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #5c74f5;"></span>
                <p class="font_14_gray legend-name">新进率</p>
                <div class="row">
                  <p class="font_24_black">{{percent(lineShowDetail.periodNewRate)}}</p>
                  <img v-show="lineShowDetail.periodNewMOM > 0" src="@/assets/icons/up@2x.png" alt />
                  <img
                    v-show="lineShowDetail.periodNewMOM < 0"
                    src="@/assets/icons/down@2x.png"
                    alt
                  />
                  <span
                    v-show="lineShowDetail.periodNewMOM != 0"
                    :class="lineShowDetail.periodNewMOM > 0 ? 'font_12_green' : 'font_12_red'"
                  >{{percent(Math.abs(lineShowDetail.periodNewMOM)) || ""}}</span>
                  <!-- <span class="font_12_red">0.66%</span> -->
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #85cf96;"></span>
                <p class="font_14_gray legend-name">离职人数</p>
                <div class="row">
                  <p class="font_24_black">{{lineShowDetail.periodExitCount}}</p>
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #85cf96;"></span>
                <p class="font_14_gray legend-name">离职率</p>
                <div class="row">
                  <p class="font_24_black">{{percent(lineShowDetail.periodLeaveRate)}}</p>
                  <img
                    v-show="lineShowDetail.periodLeaveMOM > 0"
                    src="@/assets/icons/up@2x.png"
                    alt
                  />
                  <img
                    v-show="lineShowDetail.periodLeaveMOM < 0"
                    src="@/assets/icons/down@2x.png"
                    alt
                  />
                  <span
                    v-show="lineShowDetail.periodLeaveMOM != 0"
                    :class="lineShowDetail.periodLeaveMOM > 0 ? 'font_12_green' : 'font_12_red'"
                  >{{percent(Math.abs(lineShowDetail.periodLeaveMOM)) || ""}}</span>
                  <!-- <span class="font_12_red">0.66%</span> -->
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="人员结构" name="second">
          <div class="filter">
            <!-- <el-select
              class="custom-os"
              v-model="selectedValue2"
              @change="changeHandle2_1"
              clearable
              filterable
              default-first-option
              size="medium"
              placeholder="请选择组织或输入关键字搜索"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </div>
          <div class="pie-group white_box">
            <div class="box mb50">
              <div id="pie1"></div>
              <div class="download" >
                <a class="download_pic" @click="downloadPicture('pie1', '在职员工性别分布图')">保存图片</a>
                
              </div>
            </div>
            <div class="box mb50">
              <div id="pie2"></div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('pie2', '在职员工性质分布图')">保存图片</a>
                
              </div>
            </div>
            <div class="box">
              <div id="pie3"></div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('pie3', '在职员工学历结构图')">保存图片</a>
                
              </div>
            </div>
            <div class="box">
              <div id="pie4"></div>
              <div class="download" id="test">
                <a class="download_pic" @click="downloadPicture('pie4', '在职员工年龄结构图')">保存图片</a>
                
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import echarts from "echarts";
// import style from "@/js/style.js";
import {
  downloadPic,
  dateConvert,
  Line,
  Pie,
  toPercent,
  zoneCheck,
  translateWidth
} from "@/js/tool.js";
import { Get, Download } from "@/js/http.js";
import { trackEvent, EVENT_CODE } from "@/js/analytics.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      num: 100,
      activeTab: "first", // 当前选择的选项卡
      customerShortName: '', // 客户简称，用于水印
      options: [],
      selectedValue: "", // 人员数量 选择的组织id
      selectedValue2: "", // 人员结构 选择的组织id
      cycle: 0, // 周期 (0-月度、1-季度、2-年度)
      cycleOptions: [
        {
          value: 0,
          label: "月度"
        },
        {
          value: 1,
          label: "季度"
        },
        {
          value: 2,
          label: "年度"
        }
      ],
      during: [], // 时间区间，array或null，包含开始时间和结束时间的Date对象

      zoneObj: {}, // 时间区间已选的时间点
      // 日期选择器高级选项
      pickerOptions: {
        // 禁用机制
        disabledDate: time => {
          if (this.cycle === 0) {
            // 月度不限制
            return false;
          } else {
            let type = this.cycle === 2 ? "year" : "quarter";
            if (!this.zoneObj.maxDate && this.zoneObj.minDate) {
              // 该组件默认第一个选中的为minDate
              return !zoneCheck(time, {
                type,
                selected: this.zoneObj.minDate
              });
            } else {
              return !zoneCheck(time, { type });
            }
          }
        },
        // 点击机制
        onPick: zoneObj => {
          this.zoneObj = zoneObj;
        }
      },

      lineData: {
        // xData: [
        //   "2019-01",
        //   "2019-02",
        //   "2019-03",
        //   "2019-04",
        //   "2019-05",
        //   "2019-06",
        //   "2019-07"
        // ],
        // legend: ["月末在职人数", "新进人数", "离职人数"],
        // valueData: [
        //   [120, 132, 101, 134, 90, 230, 210],
        //   [220, 182, 191, 234, 290, 330, 310],
        //   [150, 232, 201, 154, 190, 330, 410]
        // ]
      },
      lineShowDetail: {
        periodEndOnJobCount: "",
        periodNewHireCount: "",
        periodNewRate: "",
        periodExitCount: "",
        periodLeaveRate: ""
      },
      employeeNumber: 4, // 员工总数，用于人员结构统计
      chartImgUrl: ""
    };
  },
  watch: {},
  computed: {
    // 开始时间
    EffectTimeStart() {
      if (this.during) {
        return dateConvert(this.during[0]);
      } else {
        return "";
      }
    },
    // 结束时间
    EffectTimeEnd() {
      if (this.during) {
        return dateConvert(this.during[1]);
      } else {
        return "";
      }
    },
    cycleName() {
      return (
        (this.cycle === 0 && "月") ||
        (this.cycle === 1 && "季度") ||
        (this.cycle === 2 && "年度")
      );
    }
  },
  methods: {
    // 点击标签页
    handleClick() {},
    // 修改人员数量页 组织
    changeHandle1_1() {
      this.getLineData();
    },
    // 修改人员数量页 周期
    changeHandle1_2() {
      // 根据周期类型重置日期范围
      let current = new Date();
      let currentYear = current.getFullYear();
      let currentMonth = current.getMonth(); // 0-11
      
      let startDate, endDate;
      
      switch (this.cycle) {
        case 0: { // 月度
          // 最近半年：当前月往前推5个月
          startDate = new Date(currentYear, currentMonth - 5, 1);
          endDate = new Date(currentYear, currentMonth + 1, 0);
          break;
        }
        case 1: { // 季度
          // 本季度：按照用户要求的季度划分，显示完整季度
          let quarterStartMonth, quarterEndMonth;
          if (currentMonth >= 0 && currentMonth <= 2) { // 1-3月，第一季度
            quarterStartMonth = 0;
            quarterEndMonth = 2;
          } else if (currentMonth >= 3 && currentMonth <= 5) { // 4-6月，第二季度
            quarterStartMonth = 3;
            quarterEndMonth = 5;
          } else if (currentMonth >= 6 && currentMonth <= 9) { // 7-10月，第三季度
            quarterStartMonth = 6;
            quarterEndMonth = 9;
          } else { // 11-12月，第四季度
            quarterStartMonth = 11;
            quarterEndMonth = 11;
          }
          startDate = new Date(currentYear, quarterStartMonth, 1);
          endDate = new Date(currentYear, quarterEndMonth + 1, 0);
          break;
        }
        case 2: { // 年度
          // 本年：从1月1日到12月31日
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 11, 31);
          break;
        }
      }
      
      this.during = [startDate, endDate];
      this.getLineData();
    },
    // 修改人员结构页 组织
    changeHandle2_1() {
      this.getPieData();
    },
    // 修改时间区间
    zoneChange() {
      this.getLineData();
    },
    // 下载图片
    downloadPicture(id, title) {
      downloadPic(id, title, this.customerShortName);
      trackEvent(EVENT_CODE.EMPLOYMENT_DATA_DOWNLOAD, {
        chartId: id,
        chartTitle: title
      });
    },
    // 下载人员数量统计excel
    downData1() {
      Download(
        "api/v1/reports/employee/counts/excel",
        {
          // customerId: this.selectedValue,
          ReportType: this.cycle,
           BeginMonth: this.EffectTimeStart,
        EndMonth: this.EffectTimeEnd
        },
        "人员数量统计.xlsx"
      );
    },
    // 下载人员结构统计excel
    downData2(url, title, section) {
      Download(
        url,
        {
          Section: section
        },
        title
      );
    },
    // 绘制折线图
    drawLine(id, data) {
      return Line.call(this, id, data, {
        title: "人员数量统计图",
        watermarkText: this.customerShortName,
        option: {
          tooltip: {
            trigger: "axis",
            // 利用提示框formatter方法修改实例外变量
            formatter: p => {
              if (p instanceof Array) {
                this.lineShowDetail = this.sourceData1.find(
                  item => p[0].name === item.periodLabel
                );
              }
              // let output = ``;
              // p.map(item => {
              //   item;
              // output += ``;
              // })
              // return "{a} {b}: {c} ({d}%)"
            }
          }
        }
      });
    },
    // 绘制饼图
    drawPie(id, data, title) {
      return Pie.call(this, id, data, {
        title: title,
        watermarkText: this.customerShortName,
        option: {
          legend: {
            orient: "vertical",
            align: "left",
            y: "middle",
            right: "10%",
            icon: "circle",
            itemWidth: translateWidth(8),
            itemHeight: translateWidth(8),
            itemGap: translateWidth(14),
            data: data.map(item => item.name),
            formatter: name => {
              let target;
              let per;
              for (let i = 0; i < data.length; i++) {
                if (data[i].name === name) {
                  target = data[i].value;
                  per =
                    toPercent(target / this.employeeNumber, 0) === 0
                      ? "0%"
                      : toPercent(target / this.employeeNumber, 0);
                }
              }
              per;
              return (
                "{a|" + name + "}{b|" + per + "}" + "{d|" + target + "人" + "}"
              );
            },
            textStyle: {
              rich: {
                a: {
                  width: translateWidth(66),
                  fontSize: translateWidth(14),
                  color: "#949494",
                  padding: [
                    translateWidth(10),
                    translateWidth(10),
                    translateWidth(10),
                    translateWidth(4)
                  ]
                },
                b: {
                  padding: [0, translateWidth(10), 0, 0],
                  fontSize: translateWidth(24),
                  color: "#000",
                  width: translateWidth(46),
                  height: translateWidth(28),
                  verticalAlign: "top",
                  shadowColor: "#b00",
                  shadowBlur: 10,
                  shadowOffsetX: 20,
                  shadowOffsetY: 10
                },
                d: {
                  fontSize: translateWidth(14),
                  color: "#949494"
                }
              }
            }
          }
        }
      });
    },
    // 初始化时间区间
    // init() {
    //   const end = new Date();
    //   const start = new Date();
    //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
    //   this.during = [start, end];
    // },
    // 转换百分比
    percent(point) {
      return toPercent(point, 2);
    },
    // 获取客户信息（用于水印）
    getCustomerInfo() {
      Get("api/v1.0/customers/info").then(res => {
        if (res.isSuccess && res.data) {
          this.customerShortName = res.data.customerShortName || '武汉行舟';
        }
      }).catch(() => {
        this.customerShortName = '武汉行舟';
      });
    },
    // 获取组织选项
    getOptions() {
      Get("api/v1/customers/selectors").then(({ data }) => {
        this.options = data;
        // this.selectedValue = data[0].value;
        // this.selectedValue2 = data[0].value;
        // 不再在这里调用 getLineData，避免重复请求
        // this.getLineData();
        // this.getPieData();
      });
    },
    // 获取折线图数据
    getLineData() {
      // 假如未选择区间
      if(!this.during) {
        return false;
      }
      this.lineShowDetail = {
        periodEndOnJobCount: "",
        periodNewHireCount: "",
        periodNewRate: "",
        periodExitCount: "",
        periodLeaveRate: ""
      };
      Get("api/v1/reports/employee/counts", {
        // customerId: this.selectedValue,
        ReportType: this.cycle,
        BeginMonth: this.EffectTimeStart,
        EndMonth: this.EffectTimeEnd
      }).then(res => {
        let data = res.data;
        this.sourceData1 = data;
        this.lineData = {
          xData: data.map(item => item.periodLabel),
          legend: [this.cycleName + "末在职人数", "新进人数", "离职人数"],
          valueData: [
            data.map(item => item.periodEndOnJobCount),
            data.map(item => item.periodNewHireCount),
            data.map(item => item.periodExitCount)
          ]
        };
        this.line = this.drawLine("line", this.lineData);

        // 绑定鼠标移入图形事件
        // if (!this.line.had_bind_event) {
        //   this.line.on("mouseover", "series", (e) => {
        //     this.lineShowDetail = this.sourceData1.find((item) => e.name === item.xvalue);
        //   });
        //   this.line.had_bind_event = true;
        // }
      });
    },
    // 获取饼图数据
    getPieData() {
      Get("api/v1/reports/employee/structure", {
      }).then(res => {
        let data = res.data;
        this.employeeNumber = data.employeeCount;
        //性别
        let pieData1 = [
          { value: data.maleEmployeeCount, name: "男" },
          { value: data.femaleEmployeeCount, name: "女" },
          {
            value: data.employeeCount - data.maleEmployeeCount - data.femaleEmployeeCount,
            name: "未填写"
          }
        ];
        this.pieData1 = pieData1;
        this.pie1 = this.drawPie("pie1", pieData1, "在职员工性别分布图");
        //性质
        let pieData2 = [
          { value: data.jobOutsourcedEmployeeCount, name: "岗位外包" },
          { value: data.dispatchedEmployeeCount, name: "员工派遣" },
          { value: data.laborOutsourcedEmployeeCount, name: "劳务外包" },
          { value: data.payrollOutsourcedEmployeeCount, name: "薪酬代发" },
          { value: data.internCount, name: "实习生" },
          { value: data.rehiredEmployeeCount, name: "返聘" },
          { value: data.otherEmploymentTypeCount, name: "其他" },
          {
            value:
              data.employeeCount -
              data.jobOutsourcedEmployeeCount -
              data.dispatchedEmployeeCount -
              data.laborOutsourcedEmployeeCount -
              data.payrollOutsourcedEmployeeCount -
              data.internCount -
              data.rehiredEmployeeCount -
              data.otherEmploymentTypeCount,
            name: "未填写"
          }
        ];
        this.pieData2 = pieData2;
        this.pie2 = this.drawPie("pie2", pieData2, "在职员工员工性质分布图");
        //学历
        let pieData3 = [
          { value: data.belowHighSchoolCount, name: "高中以下" },
          { value: data.highSchoolCount, name: "高中" },
          { value: data.juniorCollegeCount, name: "大专" },
          { value: data.bachelorDegreeCount, name: "本科" },
          { value: data.masterAndAboveCount, name: "硕士及以上" },
          {
            value:
              data.employeeCount -
              data.belowHighSchoolCount -
              data.highSchoolCount -
              data.juniorCollegeCount -
              data.bachelorDegreeCount -
              data.masterAndAboveCount,
            name: "未填写"
          }
        ];
        this.pieData3 = pieData3;
        this.pie3 = this.drawPie("pie3", pieData3, "在职员工学历结构图");
        //年龄
        let pieData4 = [
          { value: data.age25OrBelowCount, name: "25岁及以下" },
          { value: data.age26To35Count, name: "26-35岁" },
          { value: data.age36To45Count, name: "36-45岁" },
          { value: data.age46To55Count, name: "46-55岁" },
          { value: data.ageAbove55Count, name: "55岁以上" },
          {
            value:
              data.employeeCount -
              data.age25OrBelowCount -
              data.age26To35Count -
              data.age36To45Count -
              data.age46To55Count -
              data.ageAbove55Count,
            name: "未填写"
          }
        ];
        this.pieData4 = pieData4;
        this.pie4 = this.drawPie("pie4", pieData4, "在职员工年龄结构图");
      });
    },
    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resizeCharts);
    },
    // 重新设置报表大小
    resizeCharts() {
      ["line", "pie1", "pie2", "pie3", "pie4"].forEach(item => {
        if (this[item]) {
          this[item].resize();
        }
      });
      this.drawLine("line", this.lineData);
      this.drawPie("pie1", this.pieData1, "在职员工性别分布图");
      this.drawPie("pie2", this.pieData2, "在职员工员工性质分布图");
      this.drawPie("pie3", this.pieData3, "在职员工学历结构图");
      this.drawPie("pie4", this.pieData4, "在职员工年龄结构图");
    }
  },
  created() {},
  mounted() {
    // this.init();
    this.getCustomerInfo();
    this.getOptions();
    this.changeHandle1_2();
    this.getPieData();

    this.ifResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeCharts);
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 150px 32px 24px;
  position: relative;
  .content {
    display: flex;
    padding-bottom: 94px;
    overflow-x: auto;
    .legends {
      flex: 1;
      min-width: 300px;
      padding-top: 100px;
      padding-left: 100px;
      .legend-item {
        height: 28px;
        margin-bottom: 20px;
        .point {
          width: 8px;
          height: 8px;
          margin-right: 6px;
          border-radius: 50%;
        }
        .legend-name {
          min-width: 130px;
        }
      }
    }
  }
  .filter {
    display: flex;
    padding: 22px 48px;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 32px;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .line_box {
    width: 898px;
    height: 590px;
    padding: 50px 80px 30px;
    box-shadow: 0px 4px 8px 0px rgba(55, 14, 14, 0.08),
      0px -4px 8px 0px rgba(55, 14, 14, 0.08);
    border-radius: 10px;
  }
  .pie-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 50px 32px;
    > div {
      box-shadow: 0px 4px 8px 0px rgba(55, 14, 14, 0.08),
        0px -4px 8px 0px rgba(55, 14, 14, 0.08);
      border-radius: 10px;
      margin: 10px;
    }
  }
}
// 选项卡
.el-tabs {
  ::v-deep .el-tabs__nav .el-tabs__item {
    padding: 0 49px;
    height: 64px;
    font-size: 16px;
    line-height: 64px;
    &.is-active {
      color: #f26828;
    }
    &:hover {
      color: #f26828;
    }
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #f26828;
  }
}

.box {
  position: relative;
  &.mb50 {
    margin-bottom: 50px;
  }
  .download {
    position: absolute;
    left: 0;
    bottom: 45px;
    width: 100%;
    display: flex;
    justify-content: center;
    a {
      cursor: pointer;
    }
  }
  .download_pic {
    display: inline-block;
    padding: 8px 16px;
    margin-right: 30px;
    background-color: #fff;
    border: 1px solid #f78536;
    border-radius: 4px;
    font-size: 14px;
    color: #f78536;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      background-color: #fff8f5;
      border-color: #f78536;
    }
    &:active {
      background-color: #ffe8d9;
      border-color: #f78536;
    }
  }
  .download_data {
    &:active {
      background-color: rgba(100, 100, 100, 0.1);
    }
    img {
      display: block;
    }
  }
}
#line {
  width: 722px;
  height: 400px;
  // background:url('../assets/bj.png') !important;
}
#pie1,
#pie2,
#pie3,
#pie4 {
  width: 734px;
  height: 540px;
  // background:url('../assets/bj.png') !important;
}
</style>